export default __webpack_public_path__ + "static/media/thainight6.d7c3e26f.jpg";